(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name acarsMessages.service:AcarsMessagesService
     *
     * @description
     *
     */
    angular
    	.module('acarsMessages')
        .service('AcarsMessagesService', AcarsMessagesService);

    function AcarsMessagesService(RemoteService, AcarsMessagesFactory) {
    	var self = this;

    	self.searchAcarsMessages = function(searchParam, successFn, errorFn){
    		var searchReq = AcarsMessagesFactory.getSearchRequest(searchParam);
    		RemoteService.searchAcarsMessages(searchReq).then(
				function(response) {
					if(response.success){
						successFn(response);
					}
				}, function(error) {
					errorFn(error.msg[0]);
				});
    	};
    	
    	self.appendToGridMessagesList = function (existingMessages, newMessages) {
			angular.forEach(newMessages.acarsDTOs, function (messageObj) {
				var foundIndex = _.findIndex(existingMessages.acarsDTOs, {acarsMsgId: messageObj.acarsMsgId})
				if (foundIndex >= 0) {
					existingMessages.acarsDTOs.splice(foundIndex, 1, messageObj);
				} else {
					existingMessages.acarsDTOs.push(messageObj);
				}
			});
		};

    }
})();
